import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ModalController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';
import { EditbankofficialsPage } from './editbankofficials';

/**
 * Generated class for the BankofficialsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-bankofficials',
  templateUrl: 'bankofficials.html',
})
export class BankofficialsPage {
  poiid = ''
  poiname = ''
  _Officials = []
  loadingData: boolean = true
  cb: any;

  constructor(public alertCtrl: AlertController, public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private cpService: ColorPickerService, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    this.poiid = navParams.get('poiid')
    this.poiname = navParams.get('poiname')
    this.cb = navParams.get('cb');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BankofficialsPage');
    this.loadData()
  }

  loadData() {
    this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getofficials', { poiid: this.gn.crypt(this.poiid) }, function (_data) {
      _that._Officials = _data.data
      _that.loadingData = false
      //debugger
    })
  }

  addNewOfficial() {
    var _that = this
    let modal = this.modalCtrl.create(EditbankofficialsPage, {
      official: { id: -1 }, poiid: this.poiid, cb: function () {
        _that.loadData()
        _that.cb();
      }
    }, { cssClass: "modal-fullscreenpoigroup" }
    );
    modal.present();
  }
  editOfficial(_о) {
    var _that = this
    let modal = this.modalCtrl.create(EditbankofficialsPage, {
      official: _о, poiid: this.poiid, cb: function () {
        _that.loadData()
      }
    }, { cssClass: "modal-fullscreenpoigroup" }
    );
    modal.present();
  }
  deleteOfficial(id: number, offname: string, idx: number) {
    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deleteOfficial"],
      subTitle: _that.dic.l["areyouwantodellOff"] + ' ' + offname,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delOfficial', { id: this.gn.crypt(id) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              _that._Officials.splice(idx, 1);
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/poisettings/bankofficials/bankofficials.ts